module.exports = __webpack_public_path__ + "img/interact-stu-answer-fail_new.3a5998e0.png";